import { StepDto } from '@/modules/onboarding/status/domain/dtos';
import { SectionBase } from '@/modules/onboarding/status/domain/services/onboarding-step/step';

export default class UploadDocuments implements SectionBase {
  getStepAndSubStep(): StepDto {
    return {
      step: 3,
      substep: 1,
    };
  }
}
